import {Injectable, signal, computed, NgZone, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class ScreenSizeService {
    private isSmallScreen = signal(true);
    isSmallScreen$ = computed(() => this.isSmallScreen());
    private isXLScreen = signal(true);
    isXLScreen$ = computed(() => this.isXLScreen());

    constructor(private ngZone: NgZone, @Inject(PLATFORM_ID) private platformId: Object) {
        this.updateScreenSizeVariables();
        if (isPlatformBrowser(this.platformId)) {
            this.ngZone.runOutsideAngular(() => {
                window.addEventListener('resize', () => {
                    this.ngZone.run(() => {
                        this.updateScreenSizeVariables();
                    });
                });
            });
        }
    }

    private updateScreenSizeVariables() {
        if (isPlatformBrowser(this.platformId)) {
            const isSmall = window.innerWidth < 992;
            const isXL = window.innerWidth < 1200 && window.innerWidth >= 992;

            this.isSmallScreen.set(isSmall);
            this.isXLScreen.set(isXL);
        }
    }
}

